<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/productionforecast',title:'周预测'},{title:'生产预测'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="选择日期" style="width: 50%;">
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.searchDate"
                                        :clearable="false"
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="客户名称" style="width: 50%;">
                                <el-input v-model="q.customerName" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item label="产品编码" style="width: 50%;">
                                <el-input v-model="q.productCode" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号" style="width: 50%;">
                                <el-input v-model="q.productModel" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item label="型号名称" style="width: 50%;">
                                <el-input v-model="q.modelManager" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item class="h-formBtnOut">
                                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        :border="true"
                        stripe
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="序号"
                            width="55">
                    </el-table-column>

                    <el-table-column
                            prop="operatorName"
                            label="操作人"
                            width="70">
                    </el-table-column>

                    <el-table-column
                            prop="customerName"
                            label="客户名称"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="productCode"
                            label="产品编码"
                            :width="flexColumnWidth('productCode', tableData)">
                    </el-table-column>
                    <el-table-column
                            prop="productModel"
                            label="产品型号"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="modelManager"
                            label="型号名称"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="factory"
                            label="工厂"
                            width="80">
                    </el-table-column>
                    <el-table-column
                        prop="bomVersion"
                        label="BOM版本"
                        width="110">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注"
                            width="110">
                    </el-table-column>

                    <!-- 遍历T+3到T+8周周列信息,分多级表头,第一级表头是周信息,第二级表头为周包含日信息 -->
                    <el-table-column
                            v-for="(weekInfo,index) in weekInfoList"
                            :key = "'weekColIndex'+index"
                            :label="weekInfo.weekName"
                    >
                        <el-table-column
                                v-for="(dayInfo,dayIndex) in weekInfo.weekDayList"
                                :key = "weekInfo.key+'weekDayColIndex'+dayIndex"
                                :label="dayInfo.weekDayName" width="90"
                                :prop="dayInfo.key"
                        >
                        </el-table-column>
                    </el-table-column>
                    <!-- 遍历T+9周到T+13周信息,这种的一周的预测数据默认放在每周的第一天当中,张苹定的周五 -->
                    <el-table-column
                            v-for="(weekInfo,index) in onlyWeekList"
                            :key = "'onlyWeekDayColIndex'+index"
                            :label="weekInfo.weekName"
                            width="170"
                            :prop="weekInfo.key"
                    >
                    </el-table-column>
                    <!--<el-table-column
                            fixed="right"
                            label="操作"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    style="margin-left: 0.1rem;padding: 0;"
                                    @click="handleDelete(scope.row)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="openUploadExcelDialog">批量导入
                        </el-button>
                        <upload-fore-cast-excel :visible.sync="uploadExcelDialogVisiable" v-if="uploadExcelDialogVisiable"
                                                clsname="bscProductionForecastImportExcel" :startrow="0" @downTemp="downTemp" @callback="uploadExcelFileCallback"/>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportRqExcel()">批量导出
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="handleDelete">批量删除
                        </el-button>
                    </div>
                    <div class="h-pagination2 h-pageCenter">
                        <pagination :page="page" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import UploadForeCastExcel from '../../../components/uploaddown/UploadForeCastExcel';
    import updownfile from '../../../utils/updownfile';

    export default {
        components: {
            //批量导入控件
            UploadForeCastExcel
        },
        data() {
            return {
                //是否打开导入框
                uploadExcelDialogVisiable: false,
                //查询属性
                page: {
                    //每页显示最大数量
                    pageSize: 10,
                    //当前所在页
                    pageNo: 1,
                    //总数量
                    total: 0
                },
                q: {
                    ...this.page,
                    //查询日期,根据此日期推算T+3到T+13周的年和周数
                    //获取T+3周到T+13周的周预测数量
                    searchDate: null,
                    //产品编码
                    productCode: null,
                    //客户名称
                    customerName: null,
                    //预测单编号
                    forecastNo: null,
                    //型号经理(现在保存型号名称)
                    modelManager: null,
                    //小微
                    microName: null,
                    //区域/国家
                    areaCountry: null,
                },
                //表单
                f: {
                    id: null, //
                    year: null, // 年
                    month: null, // 月
                    day: null, // 日
                    weekOfYear: null, // 当前年对应第几周
                    forecastDate: null, // 预测日期
                    quantity: null, // 数量
                    forecastId: null, // 生产预测主表ID
                },
                //table列表
                tableData: [],
                //获取根据日期查询的T+3周到T+8周信息和周下包含的天信息
                weekInfoList: [],
                //根据张苹提供模板T+9周到T+13周是整个的周预测数量
                //这里一周的预测数量保存到对应周的第一天(张苹说的时周五)
                onlyWeekList: [],
                //T+3周到T+13周需要全部日期的周数
                needAllDayWeekCount: 6
            };
        },
        created() {
            this.query();
        },
        methods: {
            //重置条件
            reset() {
                this.q = {};
                //重新进行搜索
                this.query();
            },
            //获取查询T+3周到T+13周的周信息的查询条件
            getSearchWeeksInfo() {
                let searchInfo = {};
                //设置查询日期
                searchInfo.searchDate = this.q.searchDate;
                return searchInfo;
            },
            //获取查询条件
            getSearchInfo() {
                let searchInfo = {};
                Object.assign(searchInfo, this.q);
                Object.assign(searchInfo, this.page);
                return searchInfo;
            },
            query() {
                let _self = this;
                let searchWeekInfo = _self.getSearchWeeksInfo();
                //根据检索日期查询对应的T+3周到T+13周的周信息和每个周包含的天信息
                ss.ProductionForecast.getCurTAfterWeeks(searchWeekInfo).then(res=>{
                    //T+3周到T+8周包含日期的
                    _self.weekInfoList = [];
                    //T+9周到T+13周的周数量
                    _self.onlyWeekList = [];
                    for (let i = 0; i < res.length; i++) {
                        const weekInfo = res[i];
                        if (i < _self.needAllDayWeekCount) {
                            _self.weekInfoList.push(weekInfo);
                        }else{
                            let weekData = {};
                            //T+9周到T+13周获取每个周的第一天进行封装列
                            const weekFirstDayInfo = weekInfo.weekDayList[0];
                            //设置列对应的label
                            weekData.weekName = weekInfo.weekName;
                            //设置列的KEY
                            weekData.key = weekFirstDayInfo.key;
                            //放入集合数据中
                            _self.onlyWeekList.push(weekData);
                        }
                    }
                    //获取查询条件
                    let searchInfo = _self.getSearchInfo();
                    ss.ProductionForecast.selectPage(searchInfo).then(rd => {
                        _self.page.total = rd.total;
                        _self.tableData = rd.records;
                        for (let i = 0; i < this.tableData.length; i++) {
                            let productionForecast = this.tableData[i];
                            for (let j = 0; j < productionForecast.weekDayYieldList.length; j++) {
                                const weekYield = productionForecast.weekDayYieldList[j];
                                _self.$set(productionForecast, weekYield.tableColName, weekYield.quantity);
                            }
                        }
                    });
                });
            },
            handleFilter() {
                this.query();
            },
            openUploadExcelDialog() {
                this.uploadExcelDialogVisiable = true;
            },
            uploadExcelFileCallback() {
                this.query();
            },
            //明细导出
            downTemp(){
                let search = {};
                updownfile.down(ss.ProductionForecast.downExcelTempUrl, search, 'post', 'data');
            },
            //处理删除操作
/*            handleDelete(row) {
                this.$msg.confirm("将会删除选中日期对应的T+3周到T+13周的日预测信息,删除不可逆,确认删除吗?",()=>{
                    if (row.weekDayYieldList) {
                        let delWeekDayYieldIdList = [];
                        for (let i = 0; i < row.weekDayYieldList.length; i++) {
                            const weekDayYield = row.weekDayYieldList[i];
                            delWeekDayYieldIdList.push(weekDayYield.id);
                        }
                        ss.ProductionForecast.deleteBatchByIds(delWeekDayYieldIdList).then(res=>{
                            this.$msg.msgs(res.msg);
                            this.query();
                        });
                    }
                })

            },*/
            handleDelete(row) {
                this.$msg.confirm("将会删除选中日期对应的T+3周到T+13周的日预测信息,删除不可逆,确认删除吗?",()=>{
                    let delWeekDayYieldIdList = [];
                    this.tableSelectedList.forEach((item, index) => {
                        if (item.weekDayYieldList) {
                            for (let i = 0; i < item.weekDayYieldList.length; i++) {
                                const weekDayYield = item.weekDayYieldList[i];
                                delWeekDayYieldIdList.push(weekDayYield.id);
                            }
                        }
                    })
                    if(delWeekDayYieldIdList){
                        ss.ProductionForecast.deleteBatchByIds(delWeekDayYieldIdList).then(res => {
                            this.$msg.msgs(res.msg);
                            this.query();
                        });
                    }
                })

            },
            //勾选订单list
            handleSelectionChange(lists){
                this.tableSelectedList = lists;
                var str = '';
                for(var i=0;i<lists.length;i++){
                    str += lists[i].sapCode + ',';
                }
                str = str.substring(0,str.length-1);
            },
            //自适应宽度
            flexColumnWidth(str, tableData, flag = 'max') {
                str = str + ''
                let columnContent = ''
                if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
                    return
                }
                if (!str || !str.length || str.length === 0 || str === undefined) {
                    return
                }
                if (flag === 'equal') {
                    for (let i = 0; i < tableData.length; i++) {
                        if (tableData[i][str].length > 0) {
                            columnContent = tableData[i][str]
                            break
                        }
                    }
                } else {
                    let index = 0
                    for (let i = 0; i < tableData.length; i++) {
                        if (tableData[i][str] === null) {
                            return
                        }
                        const now_temp = tableData[i][str] + ''
                        const max_temp = tableData[index][str] + ''
                        if (now_temp.length > max_temp.length) {
                            index = i
                        }
                    }
                    columnContent = tableData[index][str]
                }
                let flexWidth = 0
                for (const char of columnContent) {
                    if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                        flexWidth += 14
                    } else if (char >= 'u4e00' && char <= 'u9fa5') {
                        flexWidth += 25
                    } else {
                        flexWidth += 8
                    }
                }
                if (flexWidth < 90) {
                    flexWidth = 90 //这个值可以自定义 最小值就是110
                }
                return flexWidth + 'px'
            },
            exportRqExcel(){
                let _self = this;
                let searchWeekInfo = _self.getSearchWeeksInfo();
                //根据检索日期查询对应的T+3周到T+13周的周信息和每个周包含的天信息
                ss.ProductionForecast.getCurTAfterWeeks(searchWeekInfo).then(res=>{
                    //T+3周到T+8周包含日期的
                    _self.weekInfoList = [];
                    //T+9周到T+13周的周数量
                    _self.onlyWeekList = [];
                    for (let i = 0; i < res.length; i++) {
                        const weekInfo = res[i];
                        if (i < _self.needAllDayWeekCount) {
                            _self.weekInfoList.push(weekInfo);
                        }else{
                            let weekData = {};
                            //T+9周到T+13周获取每个周的第一天进行封装列
                            const weekFirstDayInfo = weekInfo.weekDayList[0];
                            //设置列对应的label
                            weekData.weekName = weekInfo.weekName;
                            //设置列的KEY
                            weekData.key = weekFirstDayInfo.key;
                            //放入集合数据中
                            _self.onlyWeekList.push(weekData);
                        }
                    }
                    //获取查询条件
                    let searchInfo = _self.getSearchInfo();
                    updownfile.down(ss.ProductionForecast.downExcelUrl, searchInfo, 'post', 'searchInfo');
                });
            },
        },
    };
</script>
<style scoped>
    /deep/.el-table thead.is-group th {
        background: #59b2fc;
    }
</style>